import React from 'react';
import { Link } from 'react-router-dom';

interface Benefit {
  id: number;
  icon: string;
  title: string;
  description: string;
  color: string;
}

const BenefitsSection: React.FC = () => {
  const benefits: Benefit[] = [
    {
      id: 1,
      icon: 'fas fa-route',
      title: 'Personalized Learning Journey',
      description: 'AI adapts to your unique learning style and pace, creating a customized path to success.',
      color: '#6c5ce7'
    },
    {
      id: 2,
      icon: 'fas fa-microphone-alt',
      title: 'Instant Doubt Resolution',
      description: 'Voice-powered AI assistant provides immediate answers to your questions, 24/7.',
      color: '#00b894'
    },
    {
      id: 3,
      icon: 'fas fa-bullseye',
      title: 'Focused JEE/NEET Preparation',
      description: 'Targeted content designed specifically for competitive exam success with proven strategies.',
      color: '#e17055'
    },
    {
      id: 4,
      icon: 'fas fa-chart-line',
      title: 'Real-Time Performance Tracking',
      description: 'Monitor your progress with detailed analytics and insights to optimize your preparation.',
      color: '#0984e3'
    },
    {
      id: 5,
      icon: 'fas fa-heart',
      title: 'Reduced Exam Anxiety',
      description: 'Build confidence through regular practice and personalized feedback that reduces stress.',
      color: '#fd79a8'
    },
    {
      id: 6,
      icon: 'fas fa-clock',
      title: 'Learn Anytime, Anywhere',
      description: 'Access your learning materials on any device, fitting education into your busy schedule.',
      color: '#fdcb6e'
    }
  ];

  return (
    <div className="container-fluid py-5">
      <div className="container py-5">
        <div className="text-center pb-2 wow fadeInUp" data-wow-delay="0.1s">
          <h4 className="text-primary mb-3">Why Choose WiZiAi?</h4>
          <h1 className="display-4 mb-4">Unlock Your True <span className="wiziai-gradient-text">Potential</span></h1>
          <p className="mb-1 fs-5">
            Experience the next generation of learning with AI-powered features designed for your success
          </p>
        </div>
        <div className="row g-4 justify-content-center">
          {benefits.map((benefit, index) => (
            <div key={benefit.id} className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={`${0.1 + index * 0.1}s`}>
              <div className="card h-100 shadow-sm border-0 text-center">
                <div className="card-body p-4">
                  <div className="d-flex justify-content-center mb-4">
                    <div className="rounded-circle d-flex align-items-center justify-content-center" 
                         style={{ 
                           width: '80px', 
                           height: '80px', 
                           backgroundColor: `${benefit.color}15`, 
                           border: `2px solid ${benefit.color}` 
                         }}>
                      <i className={benefit.icon} style={{ color: benefit.color, fontSize: '2rem' }}></i>
                    </div>
                  </div>
                  <h5 className="card-title fw-bold mb-3 text-dark">{benefit.title}</h5>
                  <p className="card-text text-muted mb-4">{benefit.description}</p>
                  <Link to="/benefits" className="btn btn-outline-primary">
                    Learn More <i className="fas fa-arrow-right ms-1"></i>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-5 wow fadeInUp" data-wow-delay="0.8s">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="bg-primary text-white rounded-3 p-4 p-md-5">
                <h3 className="text-white mb-3">Ready to Transform Your Learning?</h3>
                <p className="text-white-50 mb-4 fs-5">
                  Join thousands of students who are already achieving their dreams with WiZiAi
                </p>
                <div className="d-flex flex-column flex-md-row gap-3 justify-content-center">
                  <Link to="/signup" className="btn btn-light btn-lg px-4 py-3">
                    <i className="fas fa-play me-2"></i>Start Free Trial
                  </Link>
                  <Link to="/demo" className="btn btn-outline-light btn-lg px-4 py-3">
                    <i className="fas fa-calendar me-2"></i>Book a Demo
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BenefitsSection;
